import React,{useEffect, useState,forwardRef,useImperativeHandle, useLayoutEffect} from 'react'
import { Form,Input,Select, InputNumber, Tooltip, Modal,Button, message,Radio,Upload,Image } from 'antd';
import { ResDataType } from '@/services/ajax';
import { saveProduct,appList,upload } from '@/services/product';
import { PlusOutlined,QuestionCircleOutlined } from '@ant-design/icons';
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { DataType } from '../column';
import { categoryList,productTypeList,productGradeList,MAX_IMAGE_FILE_SIZE,accountTypeList,imgSizeList,ExampleImgList,TooltipTextList } from "@/constant"
const { TextArea } = Input
interface appType {
    id:number;
    name:string;
}
const ProductEdit = (props:any,ref:any) => {
    const { save } = props;
    const { curType,setCurType,isModalOpen,setIsModalOpen } = usePagAndCommon();
    const [form] = Form.useForm();
    const [curImg,setCurImg] = useState('');
    const [applist,setAppList] = useState<appType[]>([]);
    const [curProduct,setCurProduct] = useState<DataType>();
    const [previewImg,setPreviewImg] = useState<string>('');
    const [previewVisible, setPreviewVisible] = useState<any>(false);
    const [productImg,setProductImg] = useState<string>('');
    const [productIcon,setProductIcon] = useState<string>('');
    const getAppList = async () => {
        const res = await appList() as ResDataType;
        setAppList(res.data.list);
    }
    const showModal = (type:string,row?:DataType) => {
        setCurType(type);
        if(type=='edit') {
            // const fields = [
            //     "stock","arrivalTime","category","selectNum","brand","productName",
            //     "productGrade","accountType","productDesc","channelProductId",
            //     "channelAppId","parvalue","costPrice","status","productType","productIcon","productImg"
            // ];
        
            // const formValues = fields.reduce((acc, key) => {
            //     let value = (row as any)?.[key] ?? undefined;
            //     acc[key] = value;
            //     return acc;
            // }, {} as Record<string, any>);
            setCurProduct(row)
            setProductImg(row?.productImg as string)
            setProductIcon(row?.productIcon as string)
            form.setFieldsValue(row)
        } else {
            setProductImg('')
            setProductIcon('')
            form.resetFields();
            form.setFieldsValue({productType:'直充',accountType:'手机号',selectNum:0})
        } 
        getAppList();
        setIsModalOpen(true);
    };
  
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!productImg || !productIcon) {
                !productImg && message.warning('请上传权益图片');
                !productIcon && message.warning('请上传权益图标');
                return;
            }
            const data = {...values,
            id:curType=='add'? 0 :curProduct?.id,
            productImg,productIcon,status:curType=='add'? 0 : curProduct?.status};
            const res = await saveProduct(data) as ResDataType;
            if (res.code == 0) {
                message.success('保存成功');
                save();
                setIsModalOpen(false);
            } else {
                message.error(res.message); 
            }
        } catch (errorInfo: any) {
            console.log('Failed:', errorInfo);
            if (errorInfo && errorInfo.errorFields.length > 0) {
                message.error(errorInfo?.errorFields[0].errors[0]);
            }
        }
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };
    const normFile = (e: any) => {
        return [productImg];
    };

    const uploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        customRequest: ({ file, onSuccess, onError, onProgress }:any) => {
            if (file.size > MAX_IMAGE_FILE_SIZE) {
                message.error('文件大小不能超过 500KB');
                return; 
            }
          const formData = new FormData();
          formData.append('File', file);
          upload(formData).then((res:any)=> {
            onSuccess(res.data);
            if(curImg=='productImg') {
                setProductImg(res.data.url);
            } else {
                setProductIcon(res.data.url);
            }
            message.success('上传成功');})
          .catch((err:any)=> {
            onError(err);
            message.error('上传失败');}) 
        },
      };

      const imgTips = (field: keyof typeof imgSizeList) =>{
        return (
            <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList[field]}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div>
        )
      }
      const selectNumTips = ()=>{
        return (
            <div className='flexBox'>限制次数  <div style={{ fontSize:'12px',marginLeft:'5px',color:'red' }}>0为不限制</div></div>
        )
      }
      const exmpImg = (url:string)=>{
              return (
                  <div style={{ textAlign:'center',fontSize:'12px' }} ><Button type="link" onClick={()=>{
                      setPreviewImg(url)
                      setPreviewVisible(true);
                  }}>示例图</Button></div> 
              )
            }
    const toolTipContent = (title:string,tipText:string)=>{
        return (
            <div>
                {title}
                <Tooltip title={tipText} >
                    <span style={{ marginLeft:'5px' }}><QuestionCircleOutlined /></span>
                </Tooltip>
            </div>
            
        )
    }

    useImperativeHandle(ref, () => ({
        open: (type:string,row:DataType) => showModal(type,row),
    }))
    return(
        <Modal width={600} maskClosable={false} title={curType=='add'?'添加权益':'编辑权益'}  okText="确定" cancelText="取消" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
           <>
           <Form
                form={form}
                labelCol={{ span: 23 }}
                // wrapperCol={{ span: 14 }}
                layout="vertical"
                style={{ maxWidth: 600 }}
                className='formBox'
                >
                <div className='flexBox'>
                    
                </div>
                <div className='flexBox'>
                    <div style={{ width:'100%' }}>
                        <Form.Item style={{ width:'86%' }} label="品牌名称" name='brand' rules={[{ required: true, message: '请输入品牌名称' }]}>
                            <Input placeholder='请输入品牌名称' />
                        </Form.Item>
                        <Form.Item style={{ width:'86%' }} label="权益分类" name='category' rules={[{ required: true, message: '请选择权益分类' }]}>
                            <Select
                                id='value'
                                placeholder="请选择权益分类"
                                options={categoryList}
                            />
                        </Form.Item>
                        <Form.Item style={{ width:'86%' }} label="权益名称" name='productName' rules={[{ required: true, message: '请输入权益名称' }]}>
                            <Input placeholder='请输入权益名称' />
                        </Form.Item>
                    </div>
                    <Form.Item label="权益图片" name='productImg' valuePropName="productImg" getValueFromEvent={normFile}>
                        <Tooltip title={imgTips('productImg')}>
                            <Upload {...uploadProps} listType='picture-card' onChange={()=>{ setCurImg('productImg') }} >
                            {productImg ? <div className='imgBox'><img src={productImg} alt="avatar" style={{ width: '100%' }} /></div> : <button
                                style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                                type="button"
                                >
                                <PlusOutlined />
                                {imgTips('productImg')}
                                {/* <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList['productImg']}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div> */}
                                </button>}
                                
                            </Upload>
                            {exmpImg(ExampleImgList.productImg)}
                        </Tooltip>
                    </Form.Item>
                </div>
                <div className='flexBox'>
                    <Form.Item style={{ width:'70%' }} label="权益描述" name='productDesc' rules={[{ required: true, message: '请输入权益描述' }]}>
                        <TextArea style={{ height: 100, resize: 'none' }} placeholder="请输入权益描述" />
                    </Form.Item>
                    <Form.Item label="权益图标" name='productIcon' valuePropName="productIcon" getValueFromEvent={normFile}>
                        <Tooltip title={imgTips('productIcon')}>
                            <Upload {...uploadProps} listType='picture-card'  onChange={()=>{ setCurImg('productIcon') }} >
                            {productIcon ? <div className='imgBox'><img src={productIcon} alt="avatar" style={{ width: '100%' }} /></div> : <button
                                style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                                type="button"
                                >
                                <PlusOutlined />
                                {imgTips('productIcon')}
                                {/* <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList['productIcon']}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div> */}
                                </button>}
                                
                            </Upload>
                            {exmpImg(ExampleImgList.productIcon)}
                        </Tooltip>
                    </Form.Item>
                </div>
                <div className='flexBox'>
                    <Form.Item style={{ width:'33%' }} label="充值应用" name='channelAppId' rules={[{ required: true, message: '请选择充值应用' }]}>
                        <Select
                            id='id'
                            placeholder="请选择充值应用"
                            options={
                                applist.map((item:appType)=> {
                                    return {key:item.id,value:item.id,label:item.name}
                                })}
                        />
                    </Form.Item>
                    <Form.Item style={{ width:'33%' }} label={toolTipContent('渠道权益标识',TooltipTextList.channelProductId)} name='channelProductId' rules={[{ required: true, message: '请输入渠道权益标识' }]}>
                        <Input placeholder='请输入渠道权益标识' />
                    </Form.Item>
                    <Form.Item style={{ width:'33%' }} label="面值" name='parvalue' rules={[{ required: true, message: '请输入权益面值' }]}>
                        <InputNumber placeholder='请输入权益面值' style={{ width:'100%' }} min={0}/>
                    </Form.Item>
                </div>
                <div className='flexBox'>
                    <Form.Item  style={{ width:'33%' }} label="成本价" name='costPrice' rules={[{ required: true, message: '请输入权益成本价' }]}>
                        <InputNumber placeholder='请输入权益成本价' onChange={(e:any)=>{
                            let productGrade = '';
                            if (e) {
                               productGrade = e > 15 ? 'A' : (e > 10&&e < 15) ? 'B' : (e < 5 && e != 0.01) ? 'C' : e == 0.01 ? 'D' : ''; 
                            }
                            form.setFieldsValue({ productGrade });
                        }} style={{ width:'100%' }} min={0}/>
                    </Form.Item>
                    <Form.Item style={{ width:'33%' }} label="库存" name='stock' rules={[{ required: true, message: '请输入权益库存' }]}>
                        <InputNumber placeholder='请输入权益库存' style={{ width:'100%' }} min={0}/>
                    </Form.Item>
                    <Form.Item style={{ width:'33%' }} label={toolTipContent("到账时间（小时）",TooltipTextList.arrivalTime)} name='arrivalTime' rules={[{ required: true, message: '请输入权益到账时间' }]}>
                        <InputNumber placeholder="请输入权益到账时间" style={{ width:'100%' }} min={0}/>
                    </Form.Item>
                </div>
                <div className='flexBox'>
                    <Form.Item label={toolTipContent("权益档次",TooltipTextList.productGrade)} name='productGrade' rules={[{ required: true, message: '请选择权益档次' }]}>
                        <Radio.Group
                            options={productGradeList}
                            />
                    </Form.Item>
                    <Form.Item label="权益类型" name='productType' rules={[{ required: true, message: '请选择权益类型' }]}>
                        <Radio.Group
                            options={productTypeList}
                            />
                    </Form.Item>
                    <Form.Item style={{ width:'40%',marginRight:'5px' }} label={toolTipContent("账号类型",TooltipTextList.accountType)} name='accountType' rules={[{ required: true, message: '请选择账号类型' }]}>
                        <Select
                            id='value'
                            placeholder="请选择账号类型"
                            options={
                                accountTypeList.map((item:{label:string,value:string},index:number)=> {
                                    return {key:index,value:item.value,label:item.label}
                                })}
                        />
                    </Form.Item>
                    <Form.Item style={{ width:'40%' }} label={selectNumTips()} name='selectNum' rules={[{ required: true, message: '请输入限制次数' }]}>
                        <InputNumber placeholder="请输入限制次数" style={{ width:'100%' }} min={0}/>
                    </Form.Item>
                </div>
                {/* <Form.Item label="结算类型" name='settleType' rules={[{ required: true, message: '请选择权益结算类型' }]}>
                    <Radio.Group
                        options={[
                            {
                                value: 1,
                                label: '到账结算',
                            },
                            {
                                value: 2,
                                label: '核销结算',
                            }
                        ]}
                        />
                </Form.Item> */}
                
                {/* <Form.Item label="权益价值" name='valueTag' rules={[{ required: true, message: '请选择权益价值' }]}>
                    <Radio.Group
                        options={valueTagList}
                        />
                </Form.Item> */}
                
            </Form>
            <Image
                width={200}
                style={{ display: 'none' }}
                src=''
                preview={{
                    visible:previewVisible,
                    scaleStep:0.5,
                    src: previewImg,
                    onVisibleChange: (value:any) => {
                        setPreviewVisible(value);
                    },
                }}
            />
            </>
      </Modal>
    )
}

export default forwardRef(ProductEdit)